module.exports = "/_next/static/resources/array-09b60e787546da932803a97663d312e0.jpg";